import React from 'react';
import { Pagination } from 'semantic-ui-react';

const CustomPagination = ({ activePage, totalPages, onPageChange }) => {
	if (totalPages > 0)
		return (
			<div
				style={{
					flex: 1,
					justifyContent: 'center',
					display: 'flex',
					marginTop: 10,
				}}
			>
				<Pagination
					activePage={activePage}
					totalPages={totalPages}
					color='teal'
					onPageChange={onPageChange}
				/>
			</div>
		);
	else {
		return <div></div>;
	}
};

export default CustomPagination;
